import { z } from 'zod'

const envSchema = z.object({
  VITE_SUPABASE_URL: z.string().url(),
  VITE_SUPABASE_ANON_KEY: z.string().min(1),
  VITE_APP_URL: z.string().url(),
  VITE_ENVIRONMENT: z.enum(['development', 'production', 'staging']).default('development'),
})

function validateEnv() {
  const parsed = envSchema.safeParse(import.meta.env)
  
  if (!parsed.success) {
    console.error('Invalid environment variables:', parsed.error.flatten().fieldErrors)
    throw new Error('Invalid environment variables')
  }
  
  return parsed.data
}

export const env = validateEnv()
